module.exports = __webpack_public_path__ + "img/logo-symbol.ac272253.svg";